import { SchoolGroupControllerService } from 'generated';
import { useCallback, useState } from 'react';
import { apiWrapper } from 'utils/http-client';
import { handleError } from 'utils/utils';

type SchoolProfile = {
  country: string;
  country_code: string;
  currency: string;
  school_logo: string;
  school_name: string;
  school_type: string;
  tenant_id: string;
  total_staff: number;
  total_students: number;
};

type SchoolGroupDetail = {
  group_id: string;
  group_name: string;
  logo: string;
  school_in_group_projections: SchoolProfile[];
  id: string;
};

const useSchoolGroup = () => {
  const [loading, setLoading] = useState(false);
  const [loadingFilters, setLoadingFilters] = useState(false);
  const [content, setContent] = useState<any>({});
  const [filters, setFilters] = useState<any>([]);
  const [schoolGroupInfo, setSchoolGroupInfo] = useState<SchoolGroupDetail>();

  const fetchGroupInfo = useCallback(
    async (payload: { schoolGroupId: string; sessionId: string }) => {
      setLoading(true);
      try {
        const response = await apiWrapper(() =>
          SchoolGroupControllerService.getSchoolGroupUsingGet(payload),
        );

        setLoading(false);
        setSchoolGroupInfo(response);
        return { success: true, response };
      } catch (err) {
        setLoading(false);
        setSchoolGroupInfo(undefined);
        handleError(err);
        return { success: false };
      }
    },
    [],
  );

  const fetchGroupStats = useCallback(
    async (payload: { schoolGroupId: string; sessionId: string }) => {
      setLoading(true);
      try {
        const response = await apiWrapper(() =>
          SchoolGroupControllerService.getSchoolGroupStatisticsUsingGet(payload),
        );

        setLoading(false);
        setContent(response);
        return { success: true, response };
      } catch (err) {
        setLoading(false);
        setContent({});
        handleError(err);
        return { success: false };
      }
    },
    [],
  );

  const fetchGroupFilters = useCallback(
    async (payload: { schoolGroupId: string; sessionId: string }) => {
      setLoadingFilters(true);
      try {
        const response = await apiWrapper(() =>
          SchoolGroupControllerService.getFilterParametersUsingGet(payload),
        );
        setLoadingFilters(false);
        setFilters(response);
        return { success: true, response };
      } catch (err) {
        setLoadingFilters(false);
        setFilters([]);
        handleError(err);
        return { success: false };
      }
    },
    [],
  );

  return {
    loading,
    loadingFilters,
    content,
    schoolGroupInfo,
    fetchGroupStats,
    filters,
    fetchGroupFilters,
    fetchGroupInfo,
  };
};

export default useSchoolGroup;
